// Import Sentry for Client-side
import './../../sentry.client.js'

import Hls from 'hls.js'

const leontinkaUrl = process.env.BACKEND_ORIGIN_PUBLIC || 'https://www.nadaceleontinka.cz/'

let messageHTML = "<span class='info_header'>Nic nevidíš?</span>"
messageHTML += '<p>Zapni nebo povol kameru a aktualizuj stránku. Pokud se ti ani poté kamera nespustí, zkontroluj, jestli ji nemáš zakrytou.</p>'

const infoElement = document.getElementById('info')

// safari detect
const isBrowserSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
const videoWarning = document.getElementById('videoWarning')
const isAchromatopsia = document.querySelector('.achromatopsia')

if (videoWarning && isBrowserSafari) {
  videoWarning.classList.add('show')
}

if (isAchromatopsia && isBrowserSafari) {
  isAchromatopsia.classList.add('showFilter')
}

window.mobileAndTabletCheck = function () {
  let check = true;
  // eslint-disable-next-line no-useless-escape
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

// eslint-disable-next-line no-undef
if (!Modernizr.video || !Modernizr.canvas) {
  infoElement.innerHTML = '<p>Pro zobrazení si stáhněte HTML5 kompatibilní web browser prosím.</p>'
} else if (!window.mobileAndTabletCheck() && !Hls.isSupported()) {
  infoElement.innerHTML = '<p>Pro zobrazení si stáhněte HTML5 kompatibilní web browser prosím.</p>'
} else {
  // eslint-disable-next-line no-undef
  // $('#info').hide().delay(1500).html(messageHTML).fadeIn('slow') // prevents showing message early
  // eslint-disable-next-line no-undef
  $('#videoOverlay').hide().delay(750).fadeIn('fast') // prevents showing video overlay before video

  let videoLoadStarted = false
  const wrapperElement = document.getElementById('wrapper')
  // const videoWrapperElement = document.getElementById('videoWrapper')
  const menuWrapperElement = document.getElementById('menuWrapper')
  const paddleWrapperElement = document.getElementById('paddleWrapper')
  const videoElement = document.getElementById('video')
  const videoOverlayElement = document.getElementById('videoOverlay')
  const backgroundOverlayElement = document.getElementById('backgroundOverlay')

  if (!window.mobileAndTabletCheck()) {
    // set default for desktop before set video size
    videoElement.style.width = '640px'
    videoElement.style.height = '480px'
  }

  setVideoSize()
  window.onresize = function () {
    window.location.reload()
  }
  if (window.mobileAndTabletCheck()) {
    disableStreamProcessedInMenu()
  }

  // prevents elements moving when loading page
  document.getElementById('close').style.display = 'block'
  menuWrapperElement.style.display = 'block'
  paddleWrapperElement.style.display = 'block'
  setMainButtons()

  function setVideoSize () {
    let maxWidth = 9999
    if (window.mobileAndTabletCheck() && window.matchMedia('(orientation: portrait)').matches) {
      maxWidth = preventOverconstrainedError(window.innerHeight)
    } else if (window.mobileAndTabletCheck() && window.innerWidth < 1280) {
      maxWidth = preventOverconstrainedError(window.innerWidth)
    } else if (!window.mobileAndTabletCheck()) {
      // desktop max because of color blindness processing
      maxWidth = 640
    }
    wrapperElement.style.maxWidth = maxWidth + 'px'
    menuWrapperElement.style.maxWidth = (maxWidth - 100) + 'px'

    let windowWidth
    let windowHeight
    let videoWidth
    let videoHeight
    if (window.mobileAndTabletCheck() && window.matchMedia('(orientation: portrait)').matches) {
      // PORTRAIT mode
      windowWidth = window.innerHeight
      windowHeight = window.innerWidth
      videoWidth = videoElement.offsetHeight
      videoHeight = videoElement.offsetWidth
    } else {
      windowWidth = window.innerWidth
      windowHeight = window.innerHeight
      videoWidth = videoElement.offsetWidth
      videoHeight = videoElement.offsetHeight
    }

    if (windowWidth > maxWidth) {
      windowWidth = maxWidth
    }

    // find new width and height
    let newWidth, newHeight
    if (window.mobileAndTabletCheck() && window.matchMedia('(orientation: portrait)').matches) {
      // PORTRAIT mode
      if (newHeight > windowHeight) {
        newWidth = windowHeight
        newHeight = videoWidth * (windowHeight / videoHeight)
      } else {
        newWidth = maxWidth
        newHeight = windowHeight
      }
    } else {
      if (newHeight > windowHeight) {
        newWidth = videoWidth * (windowHeight / videoHeight)
        newHeight = windowHeight
      } else {
        newWidth = windowWidth
        newHeight = videoHeight * (windowWidth / videoWidth)
      }
    }

    // set wrappers width and height
    wrapperElement.width = newWidth
    wrapperElement.height = newHeight
    // videoWrapperElement.width = newWidth
    // videoWrapperElement.height = newHeight
    menuWrapperElement.width = newWidth - 100
    paddleWrapperElement.width = newWidth

    // set video elements width and height
    // videoElement.width = newWidth
    // videoElement.height = newHeight
    if (videoOverlayElement !== null) {
      videoOverlayElement.width = newWidth
      videoOverlayElement.height = newHeight
    }
    backgroundOverlayElement.width = newWidth
    backgroundOverlayElement.height = newHeight

    // mobile and tablets centering of video
    if (window.mobileAndTabletCheck()) {
      wrapperElement.style.margin = '0 auto'
      videoElement.style.margin = '0 auto'
      const videoWrapperWidth = getComputedStyle(wrapperElement).width.replace('px', '')
      if (videoWrapperWidth > videoElement.width) {
        const marginOffset = (videoWrapperWidth - videoElement.width) / 2
        if (videoOverlayElement !== null) {
          videoOverlayElement.style.left = marginOffset + 'px'
        }
        backgroundOverlayElement.style.left = marginOffset + 'px'
      }
    }

    // background image overlay positioning by CSS classes
    if (newHeight >= 480) {
      backgroundOverlayElement.classList.remove('less300')
      backgroundOverlayElement.classList.remove('less480')
      backgroundOverlayElement.classList.add('normal')
    } else if (newHeight >= 300) {
      backgroundOverlayElement.classList.remove('normal')
      backgroundOverlayElement.classList.remove('less300')
      backgroundOverlayElement.classList.add('less480')
    } else {
      backgroundOverlayElement.classList.remove('normal')
      backgroundOverlayElement.classList.remove('less480')
      backgroundOverlayElement.classList.add('less300')
    }
  }

  function preventOverconstrainedError (value) {
    if (value >= 1280) {
      return 1280
    } else if (value < 1280 && value > 900) {
      return 960
    } else {
      return 640
    }
  }

  function disableStreamProcessedInMenu () {
    // stream processing is disabled for tablets and mobiles
    if (isBrowserSafari) {
      document.getElementById('protanopia').remove()
      document.getElementById('deuteranopia').remove()
      document.getElementById('tritanopia').remove()
    }
  }

  function setMainButtons () {
    document.getElementById('logo').onclick = function () {
      window.location.href = leontinkaUrl
    }
    document.getElementById('close').onclick = function () {
      window.location.href = leontinkaUrl
    }
    document.getElementById('logo').ontouchstart = function () {
      window.location.href = leontinkaUrl
    }
    document.getElementById('close').ontouchstart = function () {
      window.location.href = leontinkaUrl
    }
  }

  window.initVideoSrc = function (transformVideoStream) {
    const constraints = {
      audio: false,
      video: {
        width: { ideal: 9999 },
        height: { ideal: 9999 },
        facingMode: { exact: 'user' }
      }
    }
    if (window.mobileAndTabletCheck()) {
      constraints.video.facingMode = { ideal: 'environment' }
    }

    if (typeof navigator.mediaDevices === 'undefined') {
      navigator.mediaDevices = {}
    }
    if (typeof navigator.mediaDevices.getUserMedia === 'undefined') {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        // First get ahold of the legacy getUserMedia, if present
        const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia
        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
          return Promise.reject(new Error('Použijte protokol HTTPS prosím.'))
        }
        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject)
        })
      }
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (stream) {
        initSuccess(stream)
      })
      .catch(function (err) {
        // eslint-disable-next-line no-undef
        $('#info').hide().delay(500).html(messageHTML).fadeIn('slow') // prevents showing message early
        if (document.getElementById('error')) document.getElementById('error').remove()
        infoElement.innerHTML += "<p id='error'>" + err.name + ': ' + err.message + '</p>'
      })

    function initSuccess (requestedStream) {
      videoElement.srcObject = requestedStream

      if (!window.mobileAndTabletCheck() && transformVideoStream && Hls.isSupported()) {
        // stream processing is disabled for tablets and mobiles
        const hls = new Hls()
        hls.loadSource(videoElement.src)
        hls.attachMedia(videoElement)
      }

      videoElement.onloadstart = function (e) {
        if (!videoLoadStarted) {
          if (document.getElementById('info')) document.getElementById('info').remove()
          videoElement.play()
          videoLoadStarted = true
        }
      }
    }
  }

  // needs jQuery
  window.initMenu = function (menuIndex) {
    // https://github.com/darsain/sly/blob/master/docs/Options.md
    const options = {
      slidee: '#menu',
      horizontal: true,
      itemNav: 'basic',
      smart: true,
      mouseDragging: true,
      touchDragging: true,
      prev: '#leftPaddle',
      next: '#rightPaddle',
      moveBy: 150,
      speed: 100,
      easing: 'swing'
    }
    // eslint-disable-next-line no-undef
    const sly = new Sly('#menuWrapper', options).init()
    sly.activate(menuIndex, [true]) // set active
    window.sly = sly
  }

  window.setVideoOverlay = function (img) {
    const imgElement = document.createElement('img')
    imgElement.src = img
    // imgElement.style.width = videoElement.width + 'px'
    // imgElement.style.height = videoElement.height + 'px'
    videoOverlayElement.appendChild(imgElement)
  }
}
